import headerBio from "../header/headerBio";

export const cardBio = () => {
    const cardsBio = document.querySelectorAll(".card-person.-bio");

    // const personsBioTriggers = document.querySelectorAll('.js-trigger-bio');
    const headerBioElement = document.querySelector('.header-bio');
    const headerBioOverlay = document.querySelector(".header-bio__overlay");
    const headerBioCloseButton = document.querySelector(".js-close-header-button");
    const closeHeaderBioButton = document.querySelector(".js-close-header-bio");

    if (cardsBio.length > 0) {

        cardsBio.forEach(element => {
            element.addEventListener('click', (e) => {
                const {currentTarget} = e;
                e.preventDefault();
                const bioButton = currentTarget.querySelector(".js-trigger-bio");
                headerBio(bioButton);
            })
        });
    }

    const closeHeaderBio = () => {
        // document.documentElement.classList.remove('no-scroll');
        headerBioElement.classList.remove('active');
    }

    headerBioOverlay.addEventListener("click", closeHeaderBio);
    closeHeaderBioButton.addEventListener("click", closeHeaderBio);
    headerBioCloseButton.addEventListener("click", closeHeaderBio);
}